(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("W5Modules", [
            'jquery',
            'jqueryTD'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('jqueryTD')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.$,
            root.jqueryTD
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, jqueryTD) {

    /**
     * JS modules of W5labs
     *
     * @constructor
     */
    function W5modules () {
        this.setModules();
    }

    W5modules.prototype = {

        /**
         * Initializing w5modules in window
         */
        setModules: function () {
            $.debounce = jqueryTD.Cowboy.debounce;

            if ( typeof window.w5modules !== "object" ) {
                window.w5modules = {};

                for ( let key in this.modules ) {
                    window.w5modules[key] = this.modules[key];
                }
            }
        },

        /**
         * Modules container
         */
        modules: {

            /**
             * Check device is mobile
             *
             * @returns {boolean}
             */
            isMobile: function () {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true;
                }

                return false;
            },

            /**
             * Load more items of collections
             *
             * @param options
             */
            loadContent: function (options) {
                let moreBtnSelector = options.containerSelector + " button.more",
                    moreBtnText = $(moreBtnSelector).text(),
                    lessBtnText = $(moreBtnSelector).data('text-less'),
                    screenWidth = window.innerWidth;

                let $items = $(options.containerSelector).find(options.itemSelector);

                /**
                 * Check enough number of elements
                 */
                if ( options.items >= $items.length ) {
                    console.warn('Not enough "'+ options.itemSelector +'" element!');
                    $(moreBtnSelector).remove();
                    return;
                }

                function init () {
                    $('body').addClass('load-content');

                    $(moreBtnSelector).html("<span>"+ moreBtnText +"</span>");

                    $items.hide().slice(0, options.items).show();

                    $(document).on('click', moreBtnSelector, function () {
                        let $btn = $(this),
                            btnText = ($btn.text() === moreBtnText) ? lessBtnText : moreBtnText;

                        $btn.find('span').animate({opacity: 0}, 250, function () {
                            $btn.find('span').text(btnText).animate({opacity: 1}, 250);
                        });

                        $items.slice(options.items, $items.length).slideToggle();
                    });
                }

                function destroy () {
                    $('body').removeClass('load-content');
                    removeButton();
                    $items.show();
                    $(document).off('click', moreBtnSelector);
                }

                function isInited () {
                    return $('body').hasClass('load-content');
                }

                function removeButton () {
                    $(moreBtnSelector).remove();
                }

                if ( screenWidth < options.destroyPoint ) {
                    init();
                } else {
                    removeButton();
                }

                $(window).on('resize', $.debounce(500, function () {
                    screenWidth = window.innerWidth;

                    if ( screenWidth >= options.destroyPoint && window.innerHeight >= 500 ) {
                        if ( isInited() ) {
                            destroy();
                        }
                    } else {
                        if ( !isInited() ) {
                            init();
                        }
                    }
                }));
            }
        }
    };

    return new W5modules();

}));



//////////////////
// WEBPACK FOOTER
// ./js/modules/w5modules/index.js
// module id = 4
// module chunks = 0 1 2 3 4